import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { itemFlirPhotoRemoveRequest, roomFlirPhotoRemoveRequest, showPhotoFlirViewer } from '../../store/photos/slice'
import { IPhotosFlir } from '../../store/photos/types'
import { systemAddDialog } from '../../store/system/slice'
import PhotoThumb from '../PhotoThumb'
import { Container } from './styles'


interface Props {
    photos: IPhotosFlir[],
    type: 'room' | 'item',
    parentId: string;
    typePhoto: "normal" | "flir"
}
const FlirPhotoGallery: React.FC<Props> = ({ photos, parentId, type, typePhoto }) => {

    const { t } = useTranslation();

    const dispatch = useDispatch()

    return <Container>

        {photos.map((photo, index) => typePhoto === "normal" && <PhotoThumb key={`photo-${photo.id}`} src={photo.link}
            onDelete={() => {
                dispatch(systemAddDialog({
                    title: t("pages.photos.dialogs.remove_photo"),
                    message: t("pages.photos.dialogs.remove_photo_message"),
                    actions: [{
                        text: t("pages.photos.buttons.remove_photo_confirm"),
                        action: () => {
                            switch (type) {
                                case 'room':
                                    dispatch(roomFlirPhotoRemoveRequest({
                                        flirPhotoId: photo.id,
                                        roomId: parentId
                                    }))
                                    break;
                                case 'item':
                                    dispatch(itemFlirPhotoRemoveRequest({
                                        flirPhotoId: photo.id,
                                        itemId: parentId
                                    }))

                                    break;
                                default:
                                    break;
                            }
                        },
                        color: 'danger',
                        prependIcon: 'trash'
                    },
                    {
                        text: t("pages.photos.buttons.remove_photo_cancel"),
                        action: () => { },
                        color: 'none'
                    }]
                }));
            }}
            onOpen={() => {
                dispatch(showPhotoFlirViewer({
                    arrayPhoto: photos.map((photo) => photo.link),
                    positionPhoto: index
                }))
            }} />
        )}

        {photos.map((photo, index) => typePhoto === "flir" && <PhotoThumb key={`photo-${photo.id}`} src={photo.flirLink}
            onDelete={() => {
                dispatch(systemAddDialog({
                    title: t("pages.photos.dialogs.remove_photo"),
                    message: t("pages.photos.dialogs.remove_photo_message"),
                    actions: [{
                        text: t("pages.photos.buttons.remove_photo_confirm"),
                        action: () => {
                            dispatch(roomFlirPhotoRemoveRequest({
                                flirPhotoId: photo.id,
                                roomId: parentId
                            }))
                        },
                        color: 'danger',
                        prependIcon: 'trash'
                    },
                    {
                        text: t("pages.photos.buttons.remove_photo_cancel"),
                        action: () => { },
                        color: 'none'
                    }]
                }));
            }}
            onOpen={() => {
                dispatch(showPhotoFlirViewer({
                    arrayPhoto: photos.map((photo) => photo.flirLink),
                    positionPhoto: index
                }))
            }} />
        )}
    </Container>
}

export default FlirPhotoGallery